import { ImpactCalculator } from "./ImpactCalculator";
import { isRecurringLike, useDonationFormStore } from "@/stores";
import type { ImpactCalculatorWithStoreProps } from "./ImpactCalculatorProps";

export function ImpactCalculatorWithStore({
  config,
  className,
}: ImpactCalculatorWithStoreProps) {
  const { donationAmount, donationType } = useDonationFormStore();

  const isMonthly = isRecurringLike(donationType);

  return (
    <ImpactCalculator
      amount={donationAmount ?? 0}
      isMonthly={isMonthly}
      config={config}
      className={className}
    />
  );
}
